module.exports = __webpack_public_path__ + "static/img/interactive-img1.65a7d40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/interactive-img1.jpg
// module id = 327
// module chunks = 64